// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__A84xY","title":"Header_title__17VvY","side":"Header_side__1chdR"};